// components
import { VehicleImage } from '../../../VehicleImage';

// styles
import { VehicleListRowImageContainerCompact } from '../../../VehicleListRowItem.interstate.style';

// types
import type { IVehicle } from '@makemydeal/dr-platform-types';

type CompactVehicleImageProps = {
    vehicle: Partial<IVehicle>;
    selected?: boolean;
};

export const CompactVehicleImage = ({ vehicle, selected }: CompactVehicleImageProps) => {
    return (
        <VehicleListRowImageContainerCompact selected={selected}>
            <VehicleImage vehicle={vehicle} className="img-responsive" />
        </VehicleListRowImageContainerCompact>
    );
};
